//#region components/dropdown/dropdown_constants.js
var e = {
	none: void 0,
	small: "d-py0",
	large: "d-py4"
}, t = { DROPDOWN_PADDING_CLASSES: e };
//#endregion
export { e as DROPDOWN_PADDING_CLASSES, t as default };

//# sourceMappingURL=dropdown-constants.js.map